"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9622],{

/***/ 389622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeroBanner_HeroBanner2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/HeroBanner2/HeroBanner2.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  flex: 1;\n  position: relative;\n\n  @media screen and (min-width: 767px) {\n    ",
        "\n  }\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  & > .next-banner-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n\n    @media screen and (max-height: 600px) {\n      object-position: center top;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n\n  @media screen and (min-width: 767px) {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    max-width: 750px;\n    flex: 1 1 0%;\n    right: 0;\n    justify-content: flex-end;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    display: flex;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 5;\n  width: 100%;\n  opacity: 1;\n  box-sizing: border-box;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    flex-direction: column;\n    padding: 0 4rem;\n    text-align: right;\n    height: 100%;\n    width: fit-content;\n    background: transparent\n      linear-gradient(90deg, #00000000 0%, #141414d8 67%, #000000e6 100%) 0% 0% no-repeat\n      padding-box;\n  }\n\n  @media screen and (max-width: 766px) {\n    text-align: center;\n    padding: 8rem 2.5rem 4rem;\n    color: ",
        ";\n    background: transparent linear-gradient(0deg, #00000000 0%, #000000 100%) 0% 0%\n      no-repeat padding-box;\n  }\n\n  @media screen and (max-height: 600px) {\n    padding: 1rem 2.5rem 2rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  overflow: hidden;\n  object-fit: cover;\n  overflow: hidden;\n  position: relative;\n\n  & > .next-store-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center center;\n  }\n\n  @media screen and (min-width: 767px) {\n    height: 77px;\n    width: 77px;\n    margin-bottom: 20px;\n    margin-left: auto;\n  }\n\n  @media screen and (max-width: 766px) {\n    height: 57px;\n    width: 57px;\n    margin: 0 auto 20px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0;\n  color: inherit;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  @media screen and (min-width: 767px) {\n    font-size: 48px;\n    margin-bottom: 20px;\n    max-width: 550px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 27px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  opacity: 0.65;\n  box-sizing: border-box;\n  -webkit-touch-callout: text;\n  -webkit-user-select: text;\n  -khtml-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n\n  @media screen and (min-width: 767px) {\n    font-size: 16px;\n    margin-bottom: 30px;\n    max-width: 470px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    margin-bottom: 20px;\n    max-width: 300px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  cursor: pointer;\n  line-height: 1.4;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 766px) {\n    text-align: center;\n    width: 100%;\n\n    & > button {\n      margin: 0 auto;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var getBannerHeight = function(props, deviceType) {
    var headerHeight = props.heightCalculation || (deviceType === "mobile" ? 80 : 90);
    if (props.bannerFixedRatio === 0) {
        // fixed height
        if (deviceType === "mobile") {
            return "height: calc(100vh - ".concat(headerHeight, "px)");
        } else {
            return "height: calc(100vh - ".concat(headerHeight, "px)");
        }
    } else {
        // fixed aspect ratio
        if (deviceType === "mobile") {
            return "height: 0; padding-top: ".concat(16 / 9 * 100, "%;");
        } else {
            return "height: 0; padding-top: ".concat(9 / 16 * 100, "%;");
        }
    }
};
var HeroBannerComponent = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    displayName: "HeroBannerComponent",
    componentId: "sc-31361e18-0"
})(_templateObject(), function(props) {
    return getBannerHeight(props, "desktop");
}, function(props) {
    return getBannerHeight(props, "mobile");
});
var HeroBannerImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "HeroBannerImage",
    componentId: "sc-31361e18-1"
})(_templateObject1());
var HeroBannerInteractivePosition = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerInteractivePosition",
    componentId: "sc-31361e18-2"
})(_templateObject2());
var HeroBannerInteractiveBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerInteractiveBody",
    componentId: "sc-31361e18-3"
})(_templateObject3(), function(props) {
    return props.fontColor;
}, function(props) {
    return props.fontColor;
});
var HeroBannerStoreImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerStoreImage",
    componentId: "sc-31361e18-4"
})(_templateObject4(), function(props) {
    return props.roundness;
});
var HeroBannerHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "HeroBannerHeading",
    componentId: "sc-31361e18-5"
})(_templateObject5());
var HeroBannerDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "HeroBannerDescription",
    componentId: "sc-31361e18-6"
})(_templateObject6());
var ViewMoreSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ViewMoreSpan",
    componentId: "sc-31361e18-7"
})(_templateObject7());
var HeroBannerCTAButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "HeroBannerCTAButton",
    componentId: "sc-31361e18-8"
})(_templateObject8());

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/bannerImageClick.js
var bannerImageClick = __webpack_require__(880841);
// EXTERNAL MODULE: ./src/utils/renderStoreName.js
var renderStoreName = __webpack_require__(616802);
// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(842783);
// EXTERNAL MODULE: ./src/hooks/useShopClickFunc.js
var useShopClickFunc = __webpack_require__(66834);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/hooks/useBannerImages.js + 1 modules
var useBannerImages = __webpack_require__(372560);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/common/BannerImageSliderNextPrevButtons.js
var BannerImageSliderNextPrevButtons = __webpack_require__(722398);
// EXTERNAL MODULE: ./src/components/DesignSystem/HeroBanner/utils.js
var utils = __webpack_require__(265710);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/heroBannerCTASystem.js
var heroBannerCTASystem = __webpack_require__(323679);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/HeroBanner2/index.js






















var HeroBanner2 = function(props) {
    var router = (0,next_router.useRouter)();
    var sliderRef = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)({
        isHeightFetched: false,
        heightFetched: 0
    }), state = ref[0], setState = ref[1];
    var heroBannerHeight = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer.heightCalculation;
    }).heroBannerHeight;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }), store_info = ref1.store_info, theme = ref1.theme;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBannerImages/* default */.Z)(), 1), bannerImages = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useShopClickFunc/* useShopClickFunc */.Y)(), 1), shopBtnClick = ref3[0];
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    (0,react.useEffect)(function() {
        if (!state.heightFetched) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    heightFetched: heroBannerHeight,
                    isHeightFetched: true
                });
            });
        }
    }, [
        heroBannerHeight
    ]);
    return theme ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "heroBannerWrapper ".concat(!(bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.length) ? "placeholder" : ""),
        children: [
            (bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImageSliderNextPrevButtons/* default */.Z, {
                sliderRef: sliderRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: function(slider) {
                    return sliderRef.current = slider;
                }
            }, utils/* sliderSettings */.K), {
                children: bannerImages === null || bannerImages === void 0 ? void 0 : bannerImages.map(function(img, idx) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(HeroBannerComponent, {
                        bannerFixedRatio: theme === null || theme === void 0 ? void 0 : theme.banner_fixed_ratio,
                        heightCalculation: state.heightFetched,
                        className: (img === null || img === void 0 ? void 0 : img.image_href) !== "" ? "pointer" : "",
                        onClick: function() {
                            return (0,bannerImageClick/* bannerImageClick */.X)(theme, img);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerImage, {
                                children: (img === null || img === void 0 ? void 0 : img.image_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                    layout: "fill",
                                    className: "next-banner-image",
                                    objectFit: "cover",
                                    objectPosition: deviceWidth/* deviceWidth */.o > 600 ? "center center" : "center top",
                                    alt: "Main Banner Image ".concat(idx + 1),
                                    src: img.image_url,
                                    priority: idx == 0
                                })
                            }),
                            idx === 0 && (((ref = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref === void 0 ? void 0 : ref.logo) || ((ref1 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref1 === void 0 ? void 0 : ref1.storeName)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerInteractivePosition, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerInteractiveBody, {
                                    fontColor: "#ffffff",
                                    children: [
                                        ((ref2 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref2 === void 0 ? void 0 : ref2.logo) && (store_info === null || store_info === void 0 ? void 0 : store_info.logo_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerStoreImage, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                                src: store_info === null || store_info === void 0 ? void 0 : store_info.logo_image,
                                                alt: "store logo",
                                                className: "next-store-image",
                                                height: "100%",
                                                width: "100%",
                                                objectFit: "cover",
                                                objectPosition: "center center"
                                            })
                                        }),
                                        ((ref3 = (0,renderStoreName/* renderStoreName */.u)(deviceWidth/* deviceWidth */.o, props === null || props === void 0 ? void 0 : props.config)) === null || ref3 === void 0 ? void 0 : ref3.storeName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerHeading, {
                                            children: store_info === null || store_info === void 0 ? void 0 : store_info.name
                                        }),
                                        store_info && (store_info === null || store_info === void 0 ? void 0 : store_info.description) && (store_info === null || store_info === void 0 ? void 0 : store_info.description.length) > 164 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBannerDescription, {
                                            children: [
                                                store_info === null || store_info === void 0 ? void 0 : store_info.description.substr(0, 164),
                                                "...",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreSpan, {
                                                    onClick: function() {
                                                        router.push((0,routes.getRoute)(routes.PATH.ABOUT_US, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
                                                    },
                                                    children: "View More"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerDescription, {
                                            children: store_info === null || store_info === void 0 ? void 0 : store_info.description
                                        }),
                                        (0,heroBannerCTASystem/* heroBannerCTASystem */.E)(theme === null || theme === void 0 ? void 0 : theme.theme_class) !== "" && (theme === null || theme === void 0 ? void 0 : (ref4 = theme.cta_config) === null || ref4 === void 0 ? void 0 : ref4.banner_cta) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBannerCTAButton, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                                                label: theme === null || theme === void 0 ? void 0 : (ref5 = theme.cta_config) === null || ref5 === void 0 ? void 0 : ref5.banner_cta,
                                                backgroundColor: "#ffffff",
                                                fontColor: "#000000",
                                                roundness: theme === null || theme === void 0 ? void 0 : theme.roundness,
                                                borderColor: "#ffffff",
                                                px: "10px",
                                                py: "10px",
                                                onClick: shopBtnClick
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, idx);
                })
            }))
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var HeroBanner_HeroBanner2 = (HeroBanner2);


/***/ }),

/***/ 372560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useBannerImages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/redux/useSSRSelector.tsx
var useSSRSelector = __webpack_require__(702808);
;// CONCATENATED MODULE: ./src/hooks/useDeviceInfo.js


function useDeviceInfo() {
    var userAgent = (0,react.useContext)(useSSRSelector/* SSRSelectorContext */.v).userAgent;
    var isMobile = mobileCheck(userAgent);
    var isDesktop = !isMobile;
    return {
        isMobile: isMobile,
        isDesktop: isDesktop,
        isInvalidDevice: isMobile === null
    };
}
function mobileCheck(userAgent) {
    if (!userAgent) return null;
    var check = false;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) check = true;
    return check;
}

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
;// CONCATENATED MODULE: ./src/components/DesignSystem/HeroBanner/hooks/useBannerImages.js





var useBannerImages = function() {
    var isBannerListImageSame = function isBannerListImageSame(imgList) {
        var isBannerListSame = true;
        if (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : bannerImagesListClient.length) {
            for(var i = 0; i < (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : bannerImagesListClient.length); i++){
                var ref, ref1;
                if ((imgList === null || imgList === void 0 ? void 0 : (ref = imgList[i]) === null || ref === void 0 ? void 0 : ref.image_url) !== (bannerImagesListClient === null || bannerImagesListClient === void 0 ? void 0 : (ref1 = bannerImagesListClient[i]) === null || ref1 === void 0 ? void 0 : ref1.image_url)) {
                    isBannerListSame = false;
                    break;
                }
            }
            return isBannerListSame;
        }
    };
    var getFilteredBannerImages = function getFilteredBannerImages(isDesktop) {
        var ref, ref1, ref2, ref3;
        var sortedImages = ((ref2 = theme === null || theme === void 0 ? void 0 : (ref = theme.components) === null || ref === void 0 ? void 0 : (ref1 = ref.Body) === null || ref1 === void 0 ? void 0 : ref1.find(function(comp) {
            return (comp === null || comp === void 0 ? void 0 : comp.sub_type) === "HeroBanner";
        })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.images) === null || ref3 === void 0 ? void 0 : ref3.sort(function(a, b) {
            return a.order - b.order;
        })) || [];
        if (isDesktop) {
            bannerImagesList = sortedImages.filter(function(el) {
                return el.is_desktop === true;
            });
        } else {
            bannerImagesList = sortedImages.filter(function(el) {
                return el.is_desktop === false;
            });
        }
        return bannerImagesList;
    };
    var ref = (0,react.useState)(false), isDocumentLoaded = ref[0], setDocumentLoaded = ref[1];
    var isDesktop = useDeviceInfo().isDesktop;
    var theme = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var bannerImagesList = [];
    // This will be false on Server & on Initial render itself
    if (!isComponentMounted) {
        bannerImagesList = getFilteredBannerImages(isDesktop);
    }
    var ref1 = (0,react.useState)(bannerImagesList || []), bannerImagesListClient = ref1[0], setBannerImagesListClient = ref1[1];
    (0,react.useEffect)(function() {
        window.addEventListener("load", function() {
            setTimeout(function() {
                return setDocumentLoaded(true);
            }, 2000);
        });
    }, []);
    (0,react.useEffect)(function() {
        var isDesktopBasedOnDeviceWidth = deviceWidth/* deviceWidth */.o > 767;
        var bannerImagesList = getFilteredBannerImages(isDesktopBasedOnDeviceWidth);
        if (!isBannerListImageSame(bannerImagesList)) {
            setBannerImagesListClient(bannerImagesList);
        }
    }, []);
    var bannerImages = !isDocumentLoaded ? bannerImagesListClient.slice(0, 1) : bannerImagesListClient;
    return [
        bannerImages
    ];
};
/* harmony default export */ var hooks_useBannerImages = (useBannerImages);


/***/ }),

/***/ 880841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ bannerImageClick; }
/* harmony export */ });
/**
 * opening new window to show banner image if image_href exists
 * @param {*} theme
 * @param {*} img
 */ var bannerImageClick = function(theme, img) {
    if ((theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) && (img === null || img === void 0 ? void 0 : img.image_href)) {
        window.open("".concat(img.image_href), "_blank");
    }
};


/***/ }),

/***/ 323679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ heroBannerCTASystem; }
/* harmony export */ });
var heroBannerCTASystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return "Shop Now";
        case 2:
            return "Explore";
        case 3:
            return "";
        case 4:
            return "";
        default:
            return "Shop Now";
    }
};


/***/ }),

/***/ 616802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ renderStoreName; }
/* harmony export */ });
/**
 * * check for existence of logo and store name in config
 * @param {*} deviceWidth number
 * @param {*} config Object
 * @return {*} obj
 */ var renderStoreName = function() {
    var deviceWidth = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var returnObj = {
        logo: true,
        storeName: true
    };
    // only for custom website config exist.
    // So for non premium website return true for logo and name
    if (deviceWidth > 720 && config && Object.keys(config).length) {
        return {
            logo: config === null || config === void 0 ? void 0 : config.show_logo,
            storeName: config === null || config === void 0 ? void 0 : config.show_store_name
        };
    }
    return returnObj;
};


/***/ }),

/***/ 471778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);

/*
  Returns isComponentMounted
  isComponentMounted -> true / Component is Successfully mounted
*/ function useIsComponentMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isComponentMounted = ref[0], setIsComponentMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsComponentMounted(true);
    }, []);
    return isComponentMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsComponentMounted);


/***/ })

}]);